import { useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'
import { truncate } from 'lodash'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { Item } from 'modules/processes/domain'
import { useDestroyItem } from 'modules/processes/hooks/useDestroyItem'

interface Props {
  onClose: () => void
  processId: number
  item: Item
}

const DeleteItemConfirmationModal = ({ item, onClose, processId }: Props) => {
  const { destroyItem } = useDestroyItem()
  const { category } = useParams()
  const { performAction, running } = useAsyncAction(async () => {
    if (!item.id) {
      throw new Error('Item ID is required')
    }
    await destroyItem(item.id, processId)
    track(trackingEvents.processes.processTaskDeleted, { isWizard: false, category })
  })

  const handleSubmit = async () => {
    const result = await performAction()
    if (result.success) {
      onClose()
    }
  }

  return (
    <Modal
      title={i18n.t('processes.process_settings.tasks.delete_modal.title', {
        name: truncate(item.title ?? ''),
      })}
      description={i18n.t('processes.process_settings.tasks.delete_modal.description', {
        name: truncate(item.title ?? ''),
      })}
      illustration="delete"
      onClose={onClose}
      onSubmit={handleSubmit}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="negative" disabled={running} submit>
            {i18n.t('processes.process_settings.tasks.delete_modal.delete')}
          </Button>
        </>
      }
    />
  )
}

export default DeleteItemConfirmationModal
